import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Phone, Zap } from "lucide-react";
import { companyInfo } from "../data/mock";

const PageHero = ({ title, subtitle, breadcrumb, image, badge }) => {
  return (
    <section className="relative overflow-hidden">
      <div
        className="h-[380px] md:h-[460px] bg-cover bg-center relative"
        style={{ backgroundImage: `url(${image})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/30" />
        <div className="relative max-w-[1400px] mx-auto px-6 h-full flex flex-col justify-end pb-12">
          {breadcrumb && (
            <nav className="flex items-center gap-2 text-sm text-white/80 mb-4">
              <Link to="/" className="hover:text-[#C9A227] transition-colors">
                Accueil
              </Link>
              <ChevronRight className="w-4 h-4" />
              <span className="text-white">{breadcrumb}</span>
            </nav>
          )}
          {badge && (
            <div className="inline-block self-start bg-[#C9A227] text-black text-xs font-bold tracking-widest uppercase px-3 py-1.5 mb-4">
              {badge}
            </div>
          )}
          <h1 className="text-4xl md:text-6xl font-black tracking-tight text-white leading-[1.05] max-w-3xl">
            {title}
          </h1>
          <div className="inline-flex items-center gap-2 self-start bg-[#123B2E]/70 text-[#C9A227] text-sm font-bold px-4 py-2 mt-4" data-testid="depannage-express-badge">
            <Zap className="w-4 h-4" />
            Dépannage express dans toute la commune
          </div>
          {subtitle && (
            <p className="text-lg text-white/90 mt-4 max-w-2xl leading-relaxed">{subtitle}</p>
          )}
        </div>
      </div>
    </section>
  );
};

export const PageCTA = ({ title, subtitle }) => (
  <section className="bg-[#C9A227] py-14">
    <div className="max-w-[1400px] mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-6">
      <div>
        <h2 className="text-2xl md:text-3xl font-black text-black tracking-tight">{title}</h2>
        {subtitle && <p className="text-black/80 mt-2">{subtitle}</p>}
      </div>
      <a
        href={`tel:${companyInfo.emergencyPhone.replace(/\s/g, "")}`}
        className="inline-flex items-center gap-3 bg-[#123B2E] text-white font-bold px-8 py-5 hover:bg-[#1B4D3C] transition-colors"
      >
        <Phone className="w-5 h-5" />
        {companyInfo.emergencyPhone}
      </a>
    </div>
  </section>
);

export default PageHero;
